import { createEntityQuery } from '../../createEntityQuery';
import {
  ConvertibleService,
  type Wealthlane_CapTable_Dtos_Convertible_ConvertibleInstrumentDto,
} from '@wealthlane/api-services/wealthlane-captable-service';

export type ConvertibleInstrumentDto = Wealthlane_CapTable_Dtos_Convertible_ConvertibleInstrumentDto;

const useConvertibleQuery = createEntityQuery<ConvertibleInstrumentDto, string>({
  queryKey: ['getConvertible'],
  queryFn: (id) => ConvertibleService.getApiCapTableApiAppConvertible(id!),
});

export function useGetConvertible(id: string | undefined, enabled = true) {
  return useConvertibleQuery(id as string, { enabled: Boolean(id) && enabled });
}
